<template>
  <div v-if="divisions.length" class="py-2">
    <div v-for="(item, index) in divisions" :key="index">
      <div class="d-flex justify-space-between align-center">
        <div>{{ item.title }}</div>
        <DivisionActions :selected="item" />
      </div>
      <v-divider v-if="index !== divisions.length - 1" class="my-2" />
    </div>
  </div>
  <div v-else>--</div>
</template>

<script>
import DivisionActions from '@/modules/division/DivisionListActions.vue'
export default {
  components: { DivisionActions },
  props: {
    divisions: Array
  },
  methods: {}
}
</script>
